export default __webpack_public_path__ + "static/Elements-20aee81019ee8971509c32e9fe6a294b.mp4";